module.exports = __webpack_public_path__ + "static/img/healthAd3.64f53bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthAd3.jpg
// module id = 5n1T
// module chunks = 1